import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Table } from "reactstrap";
import swal from "sweetalert";
import {
  isChildInHierarchy,
  LoadingSpinner,
} from "../../../../constants/const";
import { GetLanguageString, NoResult } from "../../../helper/Components";
import { ApiEvent } from "../../ApiEvent";
import SearchEventSummary from "./SearchEventSummary";
import { encryptStorage } from "../../../../constants/EncryptStorage";
import { RiFileExcel2Line, RiFilePdf2Line } from "react-icons/ri";
import { GetCustomStyles, GetSelectedLanguage } from "../../../helper/Method";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import { ShowToast } from "../../../shared/ShowToast";
import { saveAs } from "file-saver";
const EventSummary = ({ eventId, eventUnitId, eventUnitType }) => {
  const { t } = useTranslation();
  const unitTypeName = encryptStorage.getItem("unitTypeName");
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [loading, setLoading] = useState(false);
  const [searchButton, setSearchButton] = useState(false);
  const [data, setData] = useState({});

  const [searchEventSummaryModel, setSearchEventSummaryModel] = useState({
    unitId: isChildInHierarchy(unitTypeName, eventUnitType)
      ? loggedInUnitId
      : eventUnitId,
    isSubUnits: true,
    eventId: eventId,
    type: "None",
  });

  useEffect(() => {
    if (searchButton) {
      setLoading(true);
      ApiEvent()
        .GetEventAttendanceReportSummary(searchEventSummaryModel)
        .then((res) => {
          setData(res.data.eventAttendanceReport);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
        });
    }
  }, [searchButton, searchEventSummaryModel]);

  const downloadExcel = () => {
    if (searchButton) {
      const toastId = toast.loading(t("downloading_excel"));
      ApiEvent()
        .GetEventAttendanceReportSummaryExcel(searchEventSummaryModel)
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "EventAttendanceReportSummary.xlsx");
          ShowToast(toastId, "downloaded_excel", "success");
        })
        .catch((err) => {
          console.log(err);
          ShowToast(toastId, "Failed to download Excel.", "error");
        })
        .then(() => {
          setLoading(false);
        });
    }
  };

  const downloadPdf = () => {
    if (searchButton) {
      const toastId = toast.loading(t("downloading_pdf"));
      ApiEvent()
        .GetEventAttendanceReportSummaryPdf(searchEventSummaryModel)
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/pdf",
          });
          saveAs(blob, "EventAttendanceReportSummary.pdf");
          ShowToast(toastId, "downloaded_pdf", "success");
        })
        .catch((err) => {
          console.log(err);
          ShowToast(toastId, "Failed to download PDF.", "error");
        })
        .then(() => {
          setLoading(false);
        });
    }
  };

  return (
    <>
      <div className="ibox">
        <div className="ibox-title">
          <h5>{<GetLanguageString props="common_search" />}</h5>
        </div>
        <SearchEventSummary
          searchEventParticipants={searchEventSummaryModel}
          setSearchEventParticipants={setSearchEventSummaryModel}
          setSearchButton={setSearchButton}
          eventUnitType={eventUnitType}
        />
      </div>
      <ToastContainer
        autoClose={3000}
        bodyClassName={GetSelectedLanguage()}
        closeOnClick
        pauseOnHover={false}
        draggable
      />
      {searchButton ? (
        <div className="ibox">
          <div className="ibox-title">
            <h5>{<GetLanguageString props="quick_event_reports_button2" />}</h5>
            <ButtonGroup className={GetCustomStyles().btn_style}>
              <Button color="default" size="sm" onClick={downloadExcel}>
                <RiFileExcel2Line
                  size={15}
                  color="#009440"
                  style={{ marginRight: 3, marginBottom: 1 }}
                />
                {<GetLanguageString props="member_report_export_excel" />}
              </Button>
              <Button color="default" size="sm" onClick={downloadPdf}>
                <RiFilePdf2Line
                  size={15}
                  color="#FF0000"
                  className={GetCustomStyles().fa_style}
                />
                {<GetLanguageString props="member_report_export_pdf" />}
              </Button>
            </ButtonGroup>
          </div>
          <div className="ibox-content">
            {!loading ? (
              data !== undefined &&
              data !== null &&
              Object.keys(data).length !== 0 ? (
                <Table className="table-bordered m-b-none">
                  <thead>
                    <tr>
                      <th
                        style={{
                          border: "1px solid black",
                        }}
                      ></th>
                      <th
                        style={{
                          border: "1px solid black",
                        }}
                      >
                        <GetLanguageString props="report_member_mubtadi" />
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                        }}
                      >
                        <GetLanguageString props="report_member_multazim" />
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                        }}
                      >
                        <GetLanguageString props="report_member_mutazir" />
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                        }}
                      >
                        <GetLanguageString props="report_member_tawajah_talab" />
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                        }}
                      >
                        <GetLanguageString props="report_member_ahbab" />
                      </th>

                      <th
                        style={{
                          border: "1px solid black",
                        }}
                      >
                        <GetLanguageString props="report_member_visitors" />
                      </th>
                      <th
                        style={{
                          border: "2px solid black",
                        }}
                      >
                        <GetLanguageString props="unit_total_member_count" />
                      </th>
                      <th
                        style={{
                          border: "2px solid black",
                        }}
                      >
                        <GetLanguageString props="report_vacant_responsibilities_total" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data
                      .sort((a, b) => Number(a.isSearch) - Number(b.isSearch))
                      .map((item, index) => (
                        <tr key={index}>
                          <td
                            className="text-center ur"
                            style={{
                              border: item.isSearch
                                ? "2px solid black"
                                : "1px solid black",
                            }}
                          >
                            <h3>{item.isSearch ? "کل" : item.name}</h3>
                          </td>

                          <td
                            style={{
                              border: item.isSearch
                                ? "2px solid black"
                                : "1px solid black",
                            }}
                          >
                            {`${item.attendeMubtadi ?? 0} / ${
                              item.totalMubtadi ?? 0
                            } ${
                              item.mubtadi
                                ? `(${item.mubtadi.toFixed(2)}%)`
                                : "(0.0%)"
                            }`}
                          </td>
                          <td
                            style={{
                              border: item.isSearch
                                ? "2px solid black"
                                : "1px solid black",
                            }}
                          >
                            {`${item.attendeMultazim ?? 0} / ${
                              item.totalMultazim ?? 0
                            } ${
                              item.multazim
                                ? `(${item.multazim.toFixed(2)}%)`
                                : "(0.0%)"
                            }`}
                          </td>
                          <td
                            style={{
                              border: item.isSearch
                                ? "2px solid black"
                                : "1px solid black",
                            }}
                          >
                            {`${item.attendeMutazir ?? 0} / ${
                              item.totalMutazir ?? 0
                            } ${
                              item.mutazir
                                ? `(${item.mutazir.toFixed(2)}%)`
                                : "(0.0%)"
                            }`}
                          </td>
                          <td
                            style={{
                              border: item.isSearch
                                ? "2px solid black"
                                : "1px solid black",
                            }}
                          >
                            {`${item.attendeTawajahTalab ?? 0} / ${
                              item.totalTawajahTalab ?? 0
                            } ${
                              item.tawajahTalab
                                ? `(${item.tawajahTalab.toFixed(2)}%)`
                                : "(0.0%)"
                            }`}
                          </td>
                          <td
                            style={{
                              border: item.isSearch
                                ? "2px solid black"
                                : "1px solid black",
                            }}
                          >
                            {`${item.attendeAhbab ?? 0} / ${
                              item.totalAhbab ?? 0
                            } ${
                              item.ahbab
                                ? `(${item.ahbab.toFixed(2)}%)`
                                : "(0.0%)"
                            }`}
                          </td>

                          <td
                            style={{
                              border: item.isSearch
                                ? "2px solid black"
                                : "1px solid black",
                            }}
                          >
                            {`${item.attendeVisitor ?? 0} / ${
                              item.totalVisitor ?? 0
                            } ${
                              item.visitor
                                ? `(${item.visitor.toFixed(2)}%)`
                                : "(0.0%)"
                            }`}
                          </td>
                          <td
                            style={{
                              border: "2px solid black",
                            }}
                          >
                            {`${item.rufqaAttende ?? 0} / ${
                              item.rufqaTotal ?? 0
                            } ${
                              item.rufqaPercentage
                                ? `(${item.rufqaPercentage.toFixed(2)}%)`
                                : "(0.0%)"
                            }`}
                          </td>
                          <td
                            style={{
                              border: "2px solid black",
                            }}
                          >
                            {`${item.totalAttended ?? 0} / ${
                              item.totalRegistered ?? 0
                            } ${
                              item.totalPercentage
                                ? `(${item.totalPercentage.toFixed(2)}%)`
                                : "(0.0%)"
                            }`}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              ) : (
                <NoResult />
              )
            ) : (
              LoadingSpinner()
            )}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default EventSummary;
